import React from 'react';
import { Form, Icon, Message} from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoDpto} value={props.elemento._id}>{props.elemento.descrDpto}</option>
  )
};

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="dpto" id="miLista" value={permiteUpdate?argsDocum._id:idLista._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

class VerCiu2 extends React.Component {
  state={
    argsDocum: {codigoCiudad: this.props.idLista.codigoCiudad,
                nombreCiudadAnt: this.props.idLista.nombreCiudad,
                nombreCiudad: this.props.idLista.nombreCiudad,
                codigoMunicipioDANE: this.props.idLista.codigoMunicipioDANE,
                codigoPostalDANE: this.props.idLista.codigoPostalDANE,
                codigoCiudadInterno: this.props.idLista.codigoCiudadInterno?this.props.idLista.codigoCiudadInterno:"",
                codBarrasRdo: this.props.idLista.codBarrasRdo?this.props.idLista.codBarrasRdo:"",
                codigoDpto: this.props.idLista.codigoDpto,
                descrDpto: this.props.idLista.descrDpto,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      // console.log(ev.target.name)
      // console.log(ev.target)
      if(ev.target.name !== "codigoCiudad"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "dpto"){
//No se permite modificar el departamento => se comentan las lineas siguientes
          // argsDocum['_id'] = ev.target.value
          // var miLista = document.getElementById("miLista");
          // argsDocum['descrDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
        }else{
          argsDocum[ev.target.name] = ev.target.value 
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Ciudad
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codigoCiudad" id="codigoCiudad" value={argsDocum.codigoCiudad} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoCiudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="nombreCiudad" id="nombreCiudad" value={this.props.permiteUpdate?argsDocum.nombreCiudad:this.props.idLista.nombreCiudad} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreCiudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código municipio DANE</label>
                    <Form.Input autoComplete="off" name="codigoMunicipioDANE" id="codigoMunicipioDANE" value={this.props.permiteUpdate?argsDocum.codigoMunicipioDANE:this.props.idLista.codigoMunicipioDANE} onChange={this.handleChange} placeholder='Código municipio DANE' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoMunicipioDANE'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código postal</label>
                    <Form.Input autoComplete="off" name="codigoPostalDANE" id="codigoPostalDANE" value={this.props.permiteUpdate?argsDocum.codigoPostalDANE:this.props.idLista.codigoPostalDANE} onChange={this.handleChange} placeholder='Código postal' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoPostalDANE'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código interno</label>
                    <Form.Input autoComplete="off" name="codigoCiudadInterno" id="codigoCiudadInterno" value={this.props.permiteUpdate?argsDocum.codigoCiudadInterno:this.props.idLista.codigoCiudadInterno?this.props.idLista.codigoCiudadInterno:""} onChange={this.handleChange} placeholder='Código interno' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoCiudadInterno'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código de barras</label>
                    <Form.Input autoComplete="off" name="codBarrasRdo" id="codBarrasRdo" value={this.props.permiteUpdate?argsDocum.codBarrasRdo:this.props.idLista.codBarrasRdo?this.props.idLista.codBarrasRdo:""} onChange={this.handleChange} placeholder='Código de barras' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codBarrasRdo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Departamento</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default  VerCiu2
